import { ColDef, GridOptions } from "ag-grid-community"
import { format } from "date-fns";

export const stockHeaders: ColDef<any, any>[] =
[
    {headerName: "Active", field: "STOCK_ACTIVE", enableRowGroup: true},
    {headerName: "Additional Details", field: "STOCK_ADD_DETAIL", enableRowGroup: true},
    {headerName: "APN", field: "STOCK_APN", enableRowGroup: true},
    {headerName: "Created", field: "STOCK_CREATED", cellRendererSelector: (_) => {
        return { component: "dateCellRenderer" }
    }},
    {headerName: "Avg Cost", field: "STOCK_AVG_COST", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Avg Cost (End Date)", field: "STOCK_AVG_COST_END", enableRowGroup: true},
    {headerName: "Avg Value", field: "STOCK_AVG_SOH_VALUE", enableRowGroup: true},
    {headerName: "Categories", field: "STOCK_CATEGORIES", enableRowGroup: true},
    {headerName: "COGS", field: "STOCK_COGS", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Cost", field: "STOCK_COST", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Cost (End Date)", field: "STOCK_COST_END", enableRowGroup: true},
    {headerName: "Dept", field: "STOCK_DEPT", enableRowGroup: true},
    {headerName: "Full Name", field: "STOCK_FULL_NAME", enableRowGroup: true},
    {headerName: "GP$", field: "STOCK_GP", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "GP$ (End Date)", field: "STOCK_GP_END", enableRowGroup: true},
    {headerName: "Height (cm)", field: "STOCK_HEIGHT", type: 'rightAligned'},
    {headerName: "Last Inv Cost", field: "STOCK_LAST_INV", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Last Inv Cost (End Date)", field: "STOCK_LAST_INV_END", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Last Purchase", field: "STOCK_LAST_PURCHASED", enableRowGroup: true},
    {headerName: "Last Sold", field: "STOCK_LAST_SOLD", cellRendererSelector: (_) => {
        return { component: "dateCellRenderer" }
    }},
    {headerName: "Length (cm)", field: "STOCK_LENGTH", type: 'rightAligned'},
    {headerName: "Locations", field: "STOCK_LOCATIONS", enableRowGroup: true},
    {headerName: "Manufacturer", field: "STOCK_MANUFACTURER", enableRowGroup: true},
    {headerName: "Margin", field: "STOCK_MARGIN", type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "percentCellRenderer" }
    }},
    {headerName: "Margin (End Date)", field: "STOCK_MARGIN_END", enableRowGroup: true},
    {headerName: "Markup", field: "STOCK_MARKUP", type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "percentCellRenderer" }
    }},

    {headerName: "Mark Up (End Date)", field: "STOCK_MARKUP_END", enableRowGroup: true},
    {headerName: "Max Per Customer", field: "STOCK_MAX_PER_CUSTOMER", type: 'rightAligned'},
    {headerName: "MOQ", field: "STOCK_MOQ", enableRowGroup: true},
    {headerName: "PDE", field: "STOCK_PDE", enableRowGroup: true},
    {headerName: "Prev Inv Cost", field: "STOCK_PREV_INV", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Prev Inv Cost (End Date)", field: "STOCK_PREV_INV_END", enableRowGroup: true},
    {headerName: "Promo Price (End Date)", field: "STOCK_PROMO_PRICE_END_DATE", enableRowGroup: true},
    {headerName: "Qty on Ord", field: "STOCK_QTY_ON_ORDER", type: 'rightAligned'},
    {headerName: "Qty Purchased", field: "STOCK_QTY_PURCHASED", type: 'rightAligned'},
    {headerName: "Qty Purchased (By time period)", field: "STOCK_QTY_PURCHASED_TIME", type: 'rightAligned'},   
    {headerName: "Qty Sold", field: "STOCK_QTY_SOLD", type: 'rightAligned'},
    {headerName: "Qty Sold (by Time Period)", field: "STOCK_QTY_SOLD_TIME", type: 'rightAligned'},
    {headerName: "RRP", field: "STOCK_RRP", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Sales GP$", field: "STOCK_SALES_GP", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Sales GP%", field: "STOCK_SALES_MARGIN", type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "percentCellRenderer" }
    }},
    {headerName: "Sales M/Up%", field: "STOCK_SALES_MARKUP", type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "percentCellRenderer" }
    }},
    {headerName: "Sales Val", field: "STOCK_SALES_TOTAL", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Sales Val Ex", field: "STOCK_SALES_TOTAL_EX", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Schedule", field: "STOCK_SCHEDULE", enableRowGroup: true}, // didnt produce a column

    {headerName: "Sell Price", field: "STOCK_SELL_PRICE", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Sell Price (End Date)", field: "STOCK_SELL_PRICE_END", enableRowGroup: true},
    {headerName: "Sell Price Ex", field: "STOCK_SELL_PRICE_EX", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Sell Price Ex (End Date)", field: "STOCK_SELL_PRICE_EX_END", enableRowGroup: true},
    {headerName: "Stock Groups", field: "STOCK_GROUPS", enableRowGroup: true},

    {headerName: "Stock Name", field: "STOCK_NAME", enableRowGroup: true, flex: 2, minWidth: 300},
    {headerName: "Stock On Hand", field: "STOCK_SOH", type: 'rightAligned', cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "integerCellRenderer", enableRowGroup: true }
    }},
    {headerName: "Stock On Hand (End Date)", field: "STOCK_SOH_END", type: 'rightAligned', minWidth: 220, cellRendererParams: { align: "right" }, cellRendererSelector: (_) => {
        return { component: "integerCellRenderer", enableRowGroup: true }
    }},
    {headerName: "Stock Value", field: "STOCK_VALUE", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Stock Value (End Date)", field: "STOCK_VALUE_END", type: 'rightAligned', minWidth: 195, cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "Sub-Dept", field: "STOCK_SUB_DEPT", enableRowGroup: true},
    {headerName: "Supplier", field: "STOCK_SUPPLIER", enableRowGroup: true},
    {headerName: "Turnover", field: "STOCK_TURNOVER_RATE", type: 'rightAligned'},
    {headerName: "Volume (mL)", field: "STOCK_VOLUME", type: 'rightAligned'},
    {headerName: "Weight (g)", field: "STOCK_WEIGHT", type: 'rightAligned'},

    {headerName: "Width (cm)", field: "STOCK_WIDTH", type: 'rightAligned'},
    {headerName: "WS1 Cost", field: "STOCK_WS1", type: 'rightAligned', cellRendererParams: { align: "right" }, aggFunc: "sum ", cellRendererSelector: (_) => {
        return { component: "priceCellRenderer" }
    }},
    {headerName: "WS1 Cost (End Date)", field: "STOCK_WS1_END", enableRowGroup: true},
    {headerName: "Custom", field: "STOCK_CUSTOM", enableRowGroup: true }
]

export const stockReportGridOptions: GridOptions = {
    columnDefs: stockHeaders,
    defaultColDef: {
        flex: 1,

    },
    getChildCount: (data: any) => {
        return data.ROW_COUNT;
    }
}

export const SockQtySoldTime: ColDef<any, any>[] = [
    {headerName: "", field: "STOCK_QTY_SOLD_TIME0", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME1", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME2", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME3", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME4", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME5", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME6", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME7", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME8", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME9", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME10", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME11", type: 'rightAligned', hide: true, sortable: false},
    {headerName: "", field: "STOCK_QTY_SOLD_TIME12", type: 'rightAligned', hide: true, sortable: false}
]